import { Card, CardBody, Grid } from '@chakra-ui/react';
import { SupplierInquiry } from '@texas/api/endpoints/inquiryApi';
import { InquiryContactsSection } from './InquiryContactsSection';
import { InquiryIdentitySection } from './InquiryIdentitySection';
import { InquiryStatusSection } from './InquiryStatusSection';

interface Props {
  data: SupplierInquiry;
}

export function InquiryMetaCard({ data }: Props) {
  return (
    <Card
      variant="dark"
      bg="inquiryOverview.surface"
      border="1px solid"
      borderColor="inquiryOverview.softBorder"
      boxShadow="sm"
      h="full"
    >
      <CardBody p={{ base: 5, md: 6 }}>
        <Grid
          templateColumns={{
            base: '1fr',
            lg: '1.2fr 1fr',
            '2xl': '1.3fr 1fr 1fr',
          }}
          gap={0}
          h="full"
        >
          <InquiryIdentitySection data={data} />
          <InquiryContactsSection data={data} />
          <InquiryStatusSection data={data} />
        </Grid>
      </CardBody>
    </Card>
  );
}
